/**
 * O relógio do servidor visto daqui. A música (`updatedAt` do estado do áudio) e a "rolagem recente"
 * dos dados 3D (`createdAt`) são horas do servidor: comparadas com o relógio do navegador, um relógio
 * adiantado ou atrasado fazia a música saltar para outro ponto e os dados 3D sumirem.
 *
 * O desvio vem do `serverTime` do `hello` de cada conexão e, mais certo, do `pong` do ping que a store
 * manda logo depois (descontada metade da ida e volta).
 */
let offset = 0;

/** Uma hora do servidor que acabou de chegar; `roundTripMs`: a ida e volta do pedido que a trouxe. */
export function noteServerTime(serverTime: number, roundTripMs = 0, now = Date.now()): void {
  if (!Number.isFinite(serverTime) || !Number.isFinite(roundTripMs) || roundTripMs < 0) return;
  offset = serverTime + roundTripMs / 2 - now;
}

/** Agora, no relógio do servidor. */
export const serverNow = (): number => Date.now() + offset;
